export default function getLocalization(stringKey) {
  if (typeof window.connecther_screenReaderText === 'undefined' || typeof window.connecther_screenReaderText[stringKey] === 'undefined') {
    // eslint-disable-next-line no-console
    console.error(`Missing translation for ${stringKey}`);
    return '';
  }
  return window.connecther_screenReaderText[stringKey];
}
